'use strict';
var collection = require('../internals/collection');
var collectionWeak = require('../internals/collection-weak');

// `WeakSet` constructor
// https://tc39.es/ecma262/#sec-weakset-constructor
collection('WeakSet', function (init) {
  return function WeakSet() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionWeak);



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es.weak-set.constructor.js
// module id = 693
// module chunks = 0